import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CheckCircle2, Circle, ArrowRight, Sparkles } from "lucide-react";

const steps = (s) => [
  { key: "companies", tab: "companies", title: "Sigorta şirketi isimlerini birleştirin",
    done: s.company_suggestions === 0, info: s.company_suggestions ? `${s.company_suggestions} benzer isim çifti onayınızı bekliyor` : "Benzer şirket ismi kalmadı" },
  { key: "rates", tab: "rates", title: "Komisyon oranlarını girin",
    done: s.has_any_rate && !s.rate_gaps.some((g) => g.missing_types.length),
    info: (() => { const n = s.rate_gaps.filter((g) => g.missing_types.length).length; return n ? `${n} şirkette oranı olmayan poliçe tipi var` : "Tüm şirket ve tiplerin oranı tanımlı"; })() },
  { key: "agencies", tab: "agencies", title: "Acente ve kaynak isimlerini kontrol edin",
    done: s.agency_suggestions + s.referral_suggestions === 0,
    info: s.agency_suggestions + s.referral_suggestions ? `${s.agency_suggestions + s.referral_suggestions} benzer isim çifti var` : "Acente ve kaynak isimleri düzenli" },
];

export const SetupGuide = () => {
  const [st, setSt] = useState(null);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const onImport = () => api.get("/directory/setup-status").then(({ data }) => {
      setSt(data);
      if (!data.dismissed && steps(data).some((x) => !x.done)) setOpen(true);
    }).catch(() => {});
    window.addEventListener("excel-imported", onImport);
    return () => window.removeEventListener("excel-imported", onImport);
  }, []);

  const go = (tab) => { setOpen(false); nav(`/settings?tab=${tab}`); };
  const dismiss = () => { api.post("/directory/setup-dismiss").catch(() => {}); setOpen(false); };
  if (!st) return null;
  const list = steps(st);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-lg" data-testid="setup-guide">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Sparkles className="h-5 w-5 text-amber-500" /> Kurulumu tamamlayalım</DialogTitle>
          <DialogDescription>Excel aktarımı bitti. Raporların ve komisyonların doğru çıkması için 3 kısa adım:</DialogDescription>
        </DialogHeader>
        <ol className="space-y-2.5">
          {list.map((x, i) => (
            <li key={x.key} className={`flex items-start gap-3 rounded-lg border p-3.5 ${x.done ? "border-emerald-100 bg-emerald-50/50" : "border-zinc-200"}`} data-testid={`setup-step-${x.key}`}>
              {x.done ? <CheckCircle2 className="h-5 w-5 text-emerald-600 shrink-0 mt-0.5" /> : <Circle className="h-5 w-5 text-zinc-300 shrink-0 mt-0.5" />}
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-zinc-900">{i + 1}. {x.title}</p>
                <p className="text-xs text-zinc-500 mt-0.5">{x.info}</p>
              </div>
              {!x.done && (
                <Button size="sm" onClick={() => go(x.tab)} className="h-8 gap-1 bg-emerald-800 hover:bg-emerald-900 text-white shrink-0" data-testid={`setup-go-${x.key}`}>
                  Git <ArrowRight className="h-3.5 w-3.5" />
                </Button>
              )}
            </li>
          ))}
        </ol>
        <div className="flex justify-between items-center pt-1">
          <button onClick={dismiss} className="text-xs text-zinc-500 hover:text-zinc-800 underline" data-testid="setup-dismiss">Bir daha gösterme</button>
          <Button variant="outline" onClick={() => setOpen(false)} data-testid="setup-later">Sonra</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
